module.exports = __webpack_public_path__ + "img/ic_140_achievement_welcome.1de92f78.svg";